<template>
  <button class="bg-yellow-300 py-2 rounded-lg shadow"
  @touchstart="toggleAnimation($event)" @touchend="toggleAnimation($event)">
    <slot/>
  </button>
</template>

<script>
export default {
  name: "VButton",
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('bg-amber-300')
    }
  }
}
</script>

<style scoped>

</style>